/**
 * @packageDocumentation
 * @module api.functional.companies.members
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { MemberRoleDto } from "../../../structures/MemberRoleDto";

/**
 * @controller CompanyExternalController.setMemberRole
 * @path PATCH /companies/:QBOId/members/:userId
 * @accessor api.functional.companies.members.setMemberRole
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function setMemberRole(
  connection: IConnection,
  QBOId: number,
  userId: number,
  body: setMemberRole.Body,
): Promise<setMemberRole.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...setMemberRole.METADATA,
      template: setMemberRole.METADATA.path,
      path: setMemberRole.path(QBOId, userId),
    },
    body,
  );
}
export namespace setMemberRole {
  export type Body = MemberRoleDto;
  export type Output = {
    userId: number;
    isManager: boolean;
  };

  export const METADATA = {
    method: "PATCH",
    path: "/companies/:QBOId/members/:userId",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (QBOId: number, userId: number) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}/members/${encodeURIComponent(userId?.toString() ?? "null")}`;
}

/**
 * @controller CompanyExternalController.removeMember
 * @path DELETE /companies/:QBOId/members/:userId
 * @accessor api.functional.companies.members.removeMember
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function removeMember(
  connection: IConnection,
  QBOId: number,
  userId: number,
): Promise<removeMember.Output> {
  return PlainFetcher.fetch(connection, {
    ...removeMember.METADATA,
    template: removeMember.METADATA.path,
    path: removeMember.path(QBOId, userId),
  });
}
export namespace removeMember {
  export type Output = {
    ack: true;
  };

  export const METADATA = {
    method: "DELETE",
    path: "/companies/:QBOId/members/:userId",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (QBOId: number, userId: number) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}/members/${encodeURIComponent(userId?.toString() ?? "null")}`;
}
